// ** React Imports
import { ReactNode } from 'react'

// ** MUI Imports

// ** Layout Import
import BlankLayoutAppBar from 'src/layouts/BlankLayoutWithAppBar'

// ** Custom Components Imports
import DetailRekrutmen from 'src/components/rekrutmen/detail/DetailRekrutmen'
import CustomLoginSekarang from 'src/components/rekrutmen/CustomLoginSekarang'

const Jobs = () => {
  return (
    <>
      <DetailRekrutmen />
      <CustomLoginSekarang />
    </>
  )
}

Jobs.getLayout = (page: ReactNode) => <BlankLayoutAppBar>{page}</BlankLayoutAppBar>
Jobs.authGuard = false

export default Jobs
